import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DropdownOptions, DropdownSelectionComponent } from 'app/core/components/dropdown-selection/dropdown-selection.component';
import { firstValueFrom, takeUntil } from 'rxjs';

@Component({
	selector: 'sp-select',
	templateUrl: './select.component.html',
	styleUrls: ['./select.component.scss'],
})
export class SelectComponent<T> {
	@ViewChild('selectWrapper') selectWrapper!: ElementRef<HTMLDivElement>;

	// @Input() group!: FormGroup;
	// @Input() control = '';
	@Input() label = '';
	@Input() hideLabel = false;
	@Input() placeholder = '';
	@Input() description = '';
	@Input() disabled = false;
	@Input() options: DropdownOptions<T>[] = [];
	@Input() selectedOption: DropdownOptions<T> | null = null;
	@Input() comparisonFunc = (selected: T | undefined, checkValue: T): boolean => selected === checkValue;
	@Output() selected = new EventEmitter<DropdownOptions<T>>();

	optionsVisible = false;

	constructor(private dialog: MatDialog) {}

	displaySelectOptions(): void {
		if (this.optionsVisible) {
			return;
		}
		this.optionsVisible = true;
		const position = this.selectWrapper.nativeElement.getBoundingClientRect();
		const dialogRef = this.dialog.open(DropdownSelectionComponent, {
			hasBackdrop: true,
			backdropClass: 'cdk-overlay-transparent-backdrop',
			panelClass: ['overlay-dialog', 'show-overlay'],
			closeOnNavigation: true,
			width: '484px',
			maxHeight: `${window.innerHeight - position.bottom - 40}px`, // prevents dropdown from going off screen
			data: {
				options: this.options,
				currentlySelected: this.selectedOption,
				comparison: this.comparisonFunc,
			},
			position: {
				top: `${position.bottom + 10}px`,
				left: `${position.left}px`,
			},
		});

		void firstValueFrom(dialogRef.afterClosed()).then((option: DropdownOptions<T>) => {
			if (option) {
				this.selectedOption = option;
				this.selected.emit(option);
			}
			this.optionsVisible = false;
		});

		dialogRef
			.backdropClick()
			.pipe(takeUntil(dialogRef.afterClosed()))
			.subscribe(() => {
				this.optionsVisible = false;
			});
	}
}
